export const topPartnersData = [
  {
    name: 'Allstate',
    logo: 'assets/partners/allstate.webp',
    stars: 'assets/stars.png',
    reviews: '8,909 Reviews'
  },
  {
    name: 'BristolWest',
    logo: 'assets/partners/bristol-west.webp',
    stars: 'assets/stars.png',
    reviews: '9,9917 Reviews'
  },
  {
    name: 'Gabi',
    logo: 'assets/partners/gabi.webp',
    stars: 'assets/stars.png',
    reviews: '8,775 Reviews'
  },
  {
    name: 'Insurify',
    logo: 'assets/partners/insurify.webp',
    stars: 'assets/stars.png',
    reviews: '8,687 Reviews'
   },
   {
     name: 'Progressive',
     logo: 'assets/partners/progressive.webp',
     stars: 'assets/stars.png',
     reviews: '9,917 Reviews'
   },
]